import React, { Component } from 'react';

import { authHeaderJson } from '../auth-header';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Paper, LinearProgress } from '@material-ui/core';
import { ExportResult } from '../insem/ExportResult'
import IconRefresh from '@material-ui/icons/Refresh';
import IconCheck from '@material-ui/icons/CheckCircleOutline';
import IconSend from '@material-ui/icons/Send';
import CloseIcon from '@material-ui/icons/Close';
import IconError from '@material-ui/icons/ErrorOutline';
import EditIcon from '@material-ui/icons/Subject';
import CancelIcon from '@material-ui/icons/CancelOutlined';
import SaveIcon from '@material-ui/icons/Save';


import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import {
    IconButton, Dialog, Button, FormControlLabel, MenuItem, Select, Snackbar, SnackbarContent,
    FormGroup, Checkbox, Divider, Menu,
    CircularProgress, DialogContentText, AppBar, Typography, Toolbar
} from '@material-ui/core'

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit,
    },
    grow: {
        flexGrow: 1,
    },

    mail: {
        marginLeft: 30,
        marginRight: 10,
        verticalAllign: 'middle'
    },
    button: {
        margin: theme.spacing.unit,
    },
    select: {
        marginRight: theme.spacing.unit,
    },
    stat: {
        marginLeft: theme.spacing.unit,
    },
    close: {
        padding: theme.spacing.unit / 2,
    },
    error: {
        backgroundColor: theme.palette.error.dark,
    },
});


class NotificationsStatus extends Component {
    static displayName = NotificationsStatus.name;
    static months = ['Január', "Február", "Marec", "Apríl", "Máj", "Jún", "Júl", "August", "September", "Október", "November", "December"];

    constructor(props) {
        super(props);
        this.state = {
            listData: [],
            loading: true,
            period: 0,
            periods: [],
            numSelected: 0,
            selected: [],
            templates: [],
            selTemplate: 0,
            openDialog: false,
            selTemplText: '',
            anchorEl: null,
            snackOpen: false,
            sendErrSnack: false,
            result: null,
            okDataCnt: 0,
            allDataCnt: 0,
            dataPerc: 0,
            openDialogReport: false,
            genRepText: '',
            errSnackText: '',
            okSnackText: '',
        };

    };


    componentDidMount() {
        var start = new Date();
        var idx = start.getMonth();
        var year = start.getFullYear();
        var arr = [];
        for (var i = 0; i < 6; i++) {
            arr.push(NotificationsStatus.months[idx] + ' ' + year);
            idx--;
            if (idx === -1) { idx = 11; year--; }
        }
        this.setState({ periods: arr }, () => { this.loadTempl(); this.loadNots(); });
    }
    loadTempl() {
        fetch('api/NotificationTemplates', { headers: authHeaderJson() })
            .then(response => response.json())
            .then(data => {
                this.setState({ templates: data });
            })
            .catch(err => {
                console.error(err);
            });
    }

    loadNots() {
        this.setState({ loading: true }, () =>
            fetch('api/NotificationResults/ExportStatus/' + this.state.period, { headers: authHeaderJson() })
                .then(response => response.json())
                .then(data => {
                    var okData = data.filter(x => x.resultStatus === true).length;
                    var allData = data.length;

                    var start = new Date();
                    var idx = start.getMonth();
                    var year = start.getFullYear();
                    idx -= this.state.period;
                    if (idx <= 0) {
                        idx = 12 + idx;
                        year--;
                    }

                    //console.log(data);
                    this.setState({ listData: data, loading: false, okDataCnt: okData, allDataCnt: allData, dataPerc: (allData > 0) ? (100 * okData / allData) : 0, genRepText: '' + idx + '/' + year });
                })
                .catch(err => {
                    console.error(err);
                    this.setState({ loading: false, dataPerc: 0, allDataCnt: 0, okDataCnt: 0 });
                }));
    }
    saveRepReq() {
        fetch('api/NotificationResults/EnableStats/' + (this.state.period + 1), { headers: authHeaderJson() })
            .then(response => response.json())
            .then(data => {
                this.setState({ openDialogReport: false, snackOpen: true, okSnackText: 'Generovanie zostáv vyžiadané, zostavy budú vygenerované v najbližšom nasledujúcom spracovaní PLIS.' });
            })
            .catch(err => {
                console.error(err);
                this.setState({ openDialogReport: false, sendErrSnack: true, errSnackText: 'Nastal problém s povoelním generovania zostáv' });
            });
    }
    handleSelectAllClick(event) {
        if (event.target.checked) {
            const newSelecteds = this.state.listData.map(n => n.cisloStrediska);
            this.setState({ selected: newSelecteds });
            return;
        }
        this.setState({ selected: [] });
    }
    handleSelectAll(event) {
        const newSelecteds = this.state.listData.map(n => n.cisloStrediska);
        this.setState({ selected: newSelecteds });
    }
    handleSelectData(event) {
        const newSelecteds = this.state.listData.filter(x => x.dataImported).map(n => n.cisloStrediska);
        this.setState({ selected: newSelecteds });
    }
    handleSelectNoData(event) {
        const newSelecteds = this.state.listData.filter(x => !x.dataImported).map(n => n.cisloStrediska);
        this.setState({ selected: newSelecteds });
    }
    handleSelectNone(event) {
        this.setState({ selected: [] });
    }
    isSelected = id => this.state.selected.indexOf(id) !== -1;
    handleClick(event, id) {
        const selectedIndex = this.state.selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(this.state.selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(this.state.selected.slice(1));
        } else if (selectedIndex === this.state.selected.length - 1) {
            newSelected = newSelected.concat(this.state.selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                this.state.selected.slice(0, selectedIndex),
                this.state.selected.slice(selectedIndex + 1),
            );
        }

        this.setState({ selected: newSelected });
    }
    show(event, id) {

        fetch('api/NotificationResults/result/' + id, { headers: authHeaderJson() })
            .then(res => res.json())
            .then(data => {
                //          console.log(data);
                this.setState({
                    result: data,
                    dialogOpen: true
                });
            })
            .catch(err => {
                this.setState({ result: null, dialogOpen: false });
                console.error(err);
            })
    }

    renderForecastsTable(nots) {
        return (
            <Table padding="none">
                <TableHead>
                    <TableRow>
                        <TableCell padding="checkbox" >Výber</TableCell>
                        <TableCell>Insem.spol.</TableCell>
                        <TableCell>Stredisko</TableCell>
                        <TableCell>Č.stred.</TableCell>
                        <TableCell>Údaje</TableCell>
                        <TableCell></TableCell>

                    </TableRow>
                </TableHead>
                <TableBody>
                    {nots.map(not =>
                        <TableRow key={not.cisloStrediska} role="checkbox" aria-checked={this.isItemSelected}
                            selected={this.isItemSelected}
                            hover>
                            <TableCell padding="checkbox" onClick={event => { this.handleClick(event, not.cisloStrediska); }}>
                                <Checkbox checked={this.state.selected.some(x => x === not.cisloStrediska)} />
                            </TableCell>
                            <TableCell onClick={event => { this.handleClick(event, not.cisloStrediska); }}>{not.insemSpol}</TableCell>
                            <TableCell>{not.stredisko}</TableCell>
                            <TableCell>{not.cisloStrediska}</TableCell>
                            <TableCell>{not.dataImported === false ? '---' : (not.resultStatus === true ? <IconCheck /> : <IconError />)}</TableCell>
                            <TableCell>{not.dataImported === true &&
                                <IconButton onClick={event => this.show(event, not.resultId)}><EditIcon /></IconButton >}
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        );
    }


    handleChangeMonth(val) {
        this.setState({ period: val, anchorEl: null }, () => this.loadNots());
    }

    handleTemplChange(event) {
        var idx = this.state.templates.findIndex(x => x.id === event.target.value);
        this.setState({
            selTemplate: event.target.value,
            selTemplText: this.state.templates[idx].shortName
        });
    }
    sendMails() {

        fetch('api/NotificationResults/SendEmails', { headers: authHeaderJson(), method: 'post', body: JSON.stringify({ notificationId: this.state.selTemplate, units: this.state.selected }) })
            //     .then(response => response.json())
            .then(data => {

                if (data.status !== 200) {
                    console.error(data);
                    this.setState({ openDialog: false, sendErrSnack: true, errSnackText: 'Nastal problém s odosielaním mailov' });
                }
                else {
                    this.setState({ openDialog: false, snackOpen: true, okSnackText: 'Maily boli zaradené do spracovania. Výsledok bude možné skontrolovať v sekcii Prehľad činnosti' });
                }
            })
            .catch(err => {
                console.error(err);
                this.setState({ openDialog: false, sendErrSnack: true, errSnackText: 'Nastal problém s odosielaním mailov' });
            });

    }



    render() {
        const { classes } = this.props;

        const snack = (
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'right', }}
                open={this.state.snackOpen}
                autoHideDuration={6000}
                onClose={() => this.setState({ snackOpen: false })}
                message={this.state.okSnackText}
                action={
                    [
                        //<Button component={Link} key='link' to='/not-hist' size='small' color='secondary' variant='contained'>Prejsť na Prehľad činnosti</Button>,
                        <IconButton
                            key="close"
                            aria-label="Close"
                            color="inherit"
                            className={classes.close}
                            onClick={() => this.setState({ snackOpen: false })}>
                            <CloseIcon />
                        </IconButton>,
                    ]}
            />);
        const errsnack = (
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'right', }}
                open={this.state.sendErrSnack}
                autoHideDuration={6000}
                onClose={() => this.setState({ sendErrSnack: false })}
            >
                <SnackbarContent
                    className={classes.error}
                    onClose={() => this.setState({ sendErrSnack: false })}
                    ContentProps={{ 'aria-describedby': 'message-id', }}
                    message={this.state.errSnackText}
                    action={
                        [
                            <IconButton
                                key="closeErr"
                                aria-label="Close"
                                color="inherit"
                                className={classes.close}
                                onClick={() => this.setState({ sendErrSnack: false })}>
                                <CloseIcon />
                            </IconButton>,
                        ]}
                />
            </Snackbar>);

        const dialog = (
            <Dialog
                open={this.state.openDialog}
                onClose={(e) => this.setState({ openDel: false })}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Naozaj odoslať?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">Naozaj si prajete odoslať notifikáciu &quot;{this.state.selTemplText}&quot; pre vybrané strediská ({this.state.selected.length}) ?</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.sendMails.bind(this)} color="secondary">odoslať</Button>
                    <Button onClick={() => this.setState({ openDialog: false })} color="secondary" autoFocus>Zrušiť</Button>
                </DialogActions>
            </Dialog>);

        let contents = this.state.loading ? <CircularProgress /> : this.renderForecastsTable(this.state.listData);
        let labelText = "Odoslať e-mail pre vybrané strediská (" + this.state.selected.length + "): ";

        return (
            <div className={classes.root} >
                <AppBar position="static">
                    <Toolbar>
                        <Typography variant="h6" color="inherit">Stav odovzdania dát</Typography>

                        <div className={classes.grow} />
                        {this.state.periods.length > 0 &&
                            <Button color="inherit" variant="outlined"
                                aria-owns={this.state.anchorEl ? 'simple-menu' : undefined}
                                aria-haspopup="true"
                                onClick={(event) => this.setState({ anchorEl: event.currentTarget })}
                            >
                                {this.state.periods[this.state.period]}
                            </Button>
                        }
                        <Menu
                            id="simple-menu"
                            anchorEl={this.state.anchorEl}
                            open={Boolean(this.state.anchorEl)}
                            onClose={(event) => this.setState({ anchorEl: event.null })}
                        >

                            {this.state.periods.map((val, idx) => <MenuItem key={'month' + idx} value={idx} onClick={() => this.handleChangeMonth(idx)}> {val}</MenuItem>)}
                        </Menu>

                        <IconButton color="inherit" onClick={this.loadNots.bind(this)}>
                            <IconRefresh />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <Paper>
                    <Typography variant="subtitle1" className={classes.button} component="div">Nástroje</Typography>
                    <Divider />
                    <FormGroup row={true} >
                        <FormControlLabel className={classes.select} control={
                            <Typography className={classes.stat} variant='subtitle2' component='div'>Odovzdané dáta {this.state.okDataCnt}/{this.state.allDataCnt}
                                <br />
                                <LinearProgress variant='determinate' value={this.state.dataPerc} />
                            </Typography>} label='Výstupné zostavy: ' labelPlacement="start" />
                        <Button color="secondary"
                            variant="contained"
                            className={classes.button}
                            onClick={() => this.setState({ openDialogReport: true })}
                            size="small">Povoliť generovanie zostáv za {this.state.genRepText}</Button>

                    </FormGroup>
                    <Divider />
                    <FormGroup row={true} >
                        <Button color="secondary"
                            size="small"
                            disabled={this.state.selected.length === this.state.listData.length}
                            variant="contained"
                            className={classes.button}
                            onClick={this.handleSelectAll.bind(this)}>Vybrať všetky</Button>
                        <Button color="secondary"
                            size="small"
                            variant="contained"
                            onClick={this.handleSelectData.bind(this)}
                            className={classes.button}>iba odovzdané</Button>
                        <Button color="secondary"
                            size="small"
                            variant="contained"
                            onClick={this.handleSelectNoData.bind(this)}
                            className={classes.button}>iba neodovzdané</Button>
                        <Button color="secondary"
                            size="small"
                            variant="contained" disabled={this.state.selected.length === 0}
                            onClick={this.handleSelectNone.bind(this)}
                            className={classes.button}>Zrušiť výber</Button>
                    </FormGroup>
                    <Divider />
                    <FormGroup row={true} >
                        <FormControlLabel className={classes.select} control={<Select
                            value={this.state.selTemplate}
                            onChange={this.handleTemplChange.bind(this)}
                            className={classes.button}
                            inputProps={{
                                name: 'selTemplate',
                                id: 'templ-simple',
                            }}
                        >{this.state.templates.map(val => <MenuItem key={'tmpl' + val.id} value={val.id}>{val.shortName}</MenuItem>)}
                        </Select>} label={labelText} labelPlacement="start" />


                        <Button disabled={this.state.selected.length === 0 || this.state.selTemplate === 0}
                            color="secondary"
                            variant="contained"
                            className={classes.button}
                            onClick={() => this.setState({ openDialog: true })}
                            size="small"><IconSend fontSize="small" className={classes.select} />Odoslať</Button>

                    </FormGroup>
                    <Divider />
                    {contents}
                </Paper>

                {dialog}

                {snack}

                {errsnack}

                {this.state.result !== null &&
                    <Dialog
                        open={this.state.dialogOpen}
                        onClose={() => this.setState({ dialogOpen: false })}
                        aria-labelledby="responsive-dialog-title"
                        scroll="paper"
                        maxWidth="lg"
                    >
                        <DialogTitle id="responsive-dialog-title">Výsledok spracovania</DialogTitle>
                        <DialogContent>
                            <ExportResult resData={this.state.result} />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => this.setState({ dialogOpen: false })} color="secondary" variant="outlined"><CancelIcon />Zrušiť</Button>
                        </DialogActions>
                    </Dialog>
                }
                <Dialog
                    open={this.state.openDialogReport}
                    onClose={() => this.setState({ openDialogReport: false })}
                    aria-labelledby="responsive-dialog-title2"
                >
                    <DialogTitle id="responsive-dialog-title2">Výstupné zostavy</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Naozaj si prajete povoliť generovanie zostáv pre zvolené obdobie? Existujúce dáta v zostavách pre daný mesiac budú nahradené novými.
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={e => this.saveRepReq()} color="secondary" variant="outlined"><SaveIcon />Povoliť</Button>
                        <Button onClick={() => this.setState({ openDialogReport: false })} color="secondary" variant="outlined"><CancelIcon />Zrušiť</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}
NotificationsStatus.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NotificationsStatus);


// WEBPACK FOOTER //
// ./src/components/pssr/NotStatus.jsx